const TOURNAMENT_EVENT_NAME = 'tournament_flow';

type WindowWithDataLayer = Window &
	typeof globalThis & {
		dataLayer?: Record<string, string>[];
	};

export interface TournamentEventParams {
	tournamentName?: string;
	gameCode?: string;
	gameCategory?: string;
	tournamentPrize?: string | number;
	playerRank?: string | number;
	playerStars?: string | number;
	playerNickname?: string;
	isPlayerJoined?: boolean;
}

const trackTournamentEvent = (
	screenName: string,
	actionName: string,
	{
		tournamentName,
		gameCode,
		gameCategory,
		tournamentPrize,
		playerRank,
		playerStars,
		playerNickname,
		isPlayerJoined
	}: TournamentEventParams = {}
) => {
	const { dataLayer } = window as WindowWithDataLayer;
	const doesInitialMetaExist: boolean = dataLayer
		? dataLayer.findIndex(i => i.event === 'initial-meta' && i.frame === 'site') !== -1
		: false;

	const track = () => {
		(window as WindowWithDataLayer).dataLayer?.push({
			event: TOURNAMENT_EVENT_NAME,
			pixel_screen: screenName,
			pixel_tournament_action: actionName,
			pixel_tournament_name: tournamentName || 'none',
			pixel_tournament_status:
				typeof isPlayerJoined !== 'undefined' ? (isPlayerJoined ? 'joined' : 'not-joined') : 'none',
			pixel_tournament_game: gameCode || 'none',
			pixel_tournament_game_cat: gameCategory || 'none',
			pixel_tournament_prize: typeof tournamentPrize !== 'undefined' ? String(tournamentPrize) : 'none',
			pixel_tournament_c_rank: typeof playerRank !== 'undefined' ? String(playerRank) : 'none',
			pixel_tournament_stars: typeof playerStars !== 'undefined' ? String(playerStars) : 'none',
			pixel_tournament_username: playerNickname || 'none'
		});
	};

	if (doesInitialMetaExist) {
		track();
	} else {
		setTimeout(track, 1000);
	}
};

export default trackTournamentEvent;
